import * as PropTypes from 'prop-types';

export const PreferencesPropTypes = PropTypes.shape({
    assetProperties: PropTypes.arrayOf(PropTypes.string),
});
